<div class="outside-click-container" ref="childnode" @mouseover="overModal=true" @mouseout="overModal=false"><slot name="modal"></slot></div>